import React,{useContext} from "react";
import "./DisableAutoPopup.scss";
import AppContext from "../../config/AppContext";

const DisableAutoPopup = ({ open, onClose, onConfirm, title, content, confirmText, cancelText }) => {
const { mode } = useContext(AppContext);
  if (!open) return null; 

  return (
    <div className="backdrop">
      <div className={mode === "dark" ?"DisableAutoPopup-containerDark":"DisableAutoPopup-container"}>
        <span className={mode === "dark" ?"DisableAutoPopup-titleDark": "DisableAutoPopup-title"}>{title}</span>
        <span className={mode === "dark" ?"horizontal-DisableAutoPopupDark":"horizontal-DisableAutoPopup"}></span>
        <p className={mode === "dark" ?"DisableAutoPopup-contentDark":"DisableAutoPopup-content"}>
          {content}
        </p>
        <div className="DisableAuto-buttons">
          <button className={mode === "dark" ?"DisableCancel-buttonDark":"DisableCancel-button"} onClick={onClose}>
            {cancelText}
          </button>
          <button className="Disableconfirm-button" onClick={() => { onConfirm(); onClose(); }}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisableAutoPopup;
